// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "./assets/bundle." + chunkId + ".min.js?" + {"3133":"5ab2916f338ded468c02","8311":"fa1ca0474a22dd0c4b85"}[chunkId] + "";
};